import React from 'react';

interface DisclaimerModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAccept: () => void;
  title?: string;
  children?: React.ReactNode;
}

const DisclaimerModal: React.FC<DisclaimerModalProps> = ({ 
  isOpen, 
  onClose, 
  onAccept, 
  title = "PLEASE ACCEPT THESE TERMS BEFORE CONTINUING",
  children 
}) => {
  if (!isOpen) {
    return null;
  }

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const defaultContent = (
    <>
      <p>
        <strong>IMPORTANT LEGAL DISCLAIMER:</strong> This financial calculator is provided for educational and informational purposes only. The analysis, calculations, and conclusions presented are estimates based on the information you provide and certain assumptions that may not apply to your specific situation.
      </p>
      <p>
        <strong>NO FINANCIAL ADVICE:</strong> This tool is not intended to provide financial, investment, legal, or tax advice. The results should not be considered as recommendations for any financial decision. Users are strongly advised to consult with qualified financial professionals, including certified financial planners, accountants, or legal advisors before making any financial decisions.
      </p>
      <p>
        <strong>NO WARRANTIES:</strong> We make no representations or warranties regarding the accuracy, completeness, or suitability of the information provided. The calculations are estimates only and actual results may vary significantly due to market conditions, tax law changes, and other factors beyond our control.
      </p>
      <p>
        <strong>LIMITATION OF LIABILITY:</strong> By using this calculator, you acknowledge that Larry's Help and its operators shall not be liable for any damages, losses, or consequences arising from the use of this tool or reliance on its results.
      </p>
      <p>
        <strong>YOUR RESPONSIBILITY:</strong> You are responsible for verifying all calculations, understanding the assumptions used, and making your own informed decisions based on your specific circumstances and professional advice.
      </p>
    </>
  );

  return (
    <div className="modal-overlay" onClick={handleBackdropClick}>
      <div className="modal-content">
        <div className="modal-header">
          <h2 className="modal-title">{title}</h2>
          <button className="modal-close" onClick={onClose}>
            ×
          </button>
        </div>
        
        <div className="modal-body">
          {children || defaultContent}
        </div>
        
        <div className="modal-footer">
          <button className="modal-button modal-button-secondary" onClick={onClose}>
            No, I don't want to continue
          </button>
          <button className="modal-button modal-button-primary" onClick={onAccept}>
            Yes, I understand - Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default DisclaimerModal; 